import { deleteDocumentPath } from 'core/endspoints/documents';
import api from 'services/api';

export const DeleteDocument = async (documentId: string): Promise<void> => {
  const path = deleteDocumentPath(documentId);
  await api.delete(path);
};
